module.exports = __webpack_public_path__ + "static/media/leaf_animation.70d32647.gif";